'use client';

import type {FC, InputHTMLAttributes} from 'react';
import type {VariantProps} from 'class-variance-authority';
import {cva} from 'class-variance-authority';

import {cn} from '@/modules/foundation/shared/tailwind';

const input = cva(
	[
		'block min-w-0 w-full rounded-sm border-2 border-neutral-600 bg-neutral-800/50 p-2 text-neutral-100',
		'focus:ring-primary focus:ring-2 focus:ring-offset-2 focus:ring-offset-neutral-800 ',
		'read-only:bg-neutral-700 read-only:cursor-default',
		'disabled:bg-neutral-700 disabled:text-neutral-400 disabled:cursor-not-allowed ',
	],
	{
		variants: {
			size: {
				sm: 'text-sm lg:text-base h-8 lg:h-10 px-2 lg:px-3 border',
				md: 'text-base lg:text-lg h-10 lg:h-12 px-3 lg:px-4 border-2',
				lg: 'text-lg lg:text-xl h-12 lg:h-14 px-4 lg:px-5 border-2',
			},
		},
		defaultVariants: {
			size: 'md',
		},
	},
);

export type InputProps = VariantProps<typeof input> &
	Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>;

export const Input: FC<InputProps> = ({size, className, ...rest}) => {
	return <input size={1} className={cn(input({size, className}))} {...rest} />;
};
